// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__2an36","text":"Footer_text__CYP7w"};